import logger from '@achieve/cx-logger'

const APOLLO_ERROR_MESSAGE = 'Apollo Error'

export function logServerError(message, err, context = {}) {
  logger.error(message, {
    error: err,
    site: process.env.NEXT_PUBLIC_SITE_ENVIRONMENT,
    appEnv: process.env.NEXT_PUBLIC_APP_ENV,
    ...context,
  })
}

export function logApolloError(err, context = {}) {
  logServerError(APOLLO_ERROR_MESSAGE, err, context)
}
